<template>
	<button
		type="button"
		class="site-menu-trigger"
		:class="{ 'site-menu-trigger--compact': compact }"
		:aria-label="siteTitle"
		@click="openNavigation"
	>
		<img class="site-menu-trigger__icon" :src="menuIcon" alt="" />
		<span class="site-menu-trigger__title">{{ siteTitle }}</span>
	</button>
</template>

<script>
import menuIcon from '../views/images/common/more.png';

export default {
	name: 'SiteMenuTrigger',
	props: {
		compact: {
			type: Boolean,
			default: false,
		},
	},
	inject: {
		siteNavigation: {
			default: () => null,
		},
	},
	computed: {
		siteTitle() {
			const title = this.siteNavigation && this.siteNavigation.title;
			if (typeof title === 'string' && title.trim()) return title.trim();
			if (typeof document !== 'undefined' && document.title) return document.title;
			return 'DEFI';
		},
	},
	data() {
		return {
			menuIcon,
		};
	},
	methods: {
		openNavigation() {
			if (this.siteNavigation && typeof this.siteNavigation.open === 'function') {
				this.siteNavigation.open();
			}
		},
	},
};
</script>

<style scoped lang="less">
.site-menu-trigger {
	display: inline-flex;
	min-height: 36px;
	min-width: 0;
	max-width: 150px;
	align-items: center;
	gap: 5px;
	padding: 0 11px 0 2px;
	border: 1px solid #48423b;
	border-radius: 20px;
	background: #0c0c0c;
	box-shadow: 0 5px 12px rgba(0, 0, 0, .32);
	color: #ffcf26;
	cursor: pointer;
	text-align: left;
}

.site-menu-trigger__icon {
	flex: 0 0 34px;
	width: 34px;
	height: 34px;
	border-radius: 50%;
	filter: grayscale(1) sepia(.22) saturate(1.1) brightness(.86) contrast(1.06);
	object-fit: contain;
}

.site-menu-trigger__title {
	overflow: hidden;
	font-size: 14px;
	font-weight: 700;
	line-height: 1.2;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.site-menu-trigger--compact {
	max-width: 132px;
	padding: 4px 10px 4px 4px;
	border: 1px solid rgba(255, 207, 38, .24);
	border-radius: 20px;
	background: #0c0c0c;
	box-shadow: 0 5px 16px rgba(0, 0, 0, .28);
}

.site-menu-trigger--compact .site-menu-trigger__icon {
	flex-basis: 28px;
	width: 28px;
	height: 28px;
}

.site-menu-trigger--compact .site-menu-trigger__title {
	font-size: 12px;
}

@media screen and (max-width: 390px) {
	.site-menu-trigger:not(.site-menu-trigger--compact) {
		max-width: 86px;
		gap: 4px;
	}

	.site-menu-trigger:not(.site-menu-trigger--compact) .site-menu-trigger__icon {
		flex-basis: 30px;
		width: 30px;
		height: 30px;
	}

	.site-menu-trigger:not(.site-menu-trigger--compact) .site-menu-trigger__title {
		font-size: 12px;
	}
}
</style>
